
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/itsolutions",
      function () {
        return require("private-next-pages/itsolutions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/itsolutions"])
      });
    }
  